import React, { useEffect, useState } from 'react'
import { FaExternalLinkAlt, FaGithub } from 'react-icons/fa'
import { TbZoomInArea } from 'react-icons/tb'
import Loading from '../components/Loading'
import Modal from '../components/Modal'
import PageTitle from '../components/PageTitle'
import { webProjects } from '../data'

const Portfolio = () => {
  const [show, setshow] = useState(false)
  const [loading, setLoading] = useState(true)
  const [projectview, setprojectview] = useState({
    title: '',
    src: '',
    tags: [],
    url:'',
    github:''
  })

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }, [])


  return (
    <section className='portfolio_page'>
      <PageTitle title='Portfolio' />
      <h1>Here some of my web projects works. I wish you find some of what are you looking for.</h1>
      <Modal setshow={setshow} show={show}>
        {
          <div className='design_card'>
            <h3>{projectview?.title}</h3>
            <img src={projectview?.src} alt={projectview?.title} />
            <div className="btns">
                <a href={projectview.github} className='btn github' target='_blank' rel='noreferrer'><FaGithub/> View code</a>
              <a href={projectview.url} className='btn view' target='_blank' rel='noreferrer'><FaExternalLinkAlt/> View demo</a>
            </div>
            <div className="tags">
              {
                projectview?.tags.map((tag, idx) => {
                  return (
                    <span key={idx}>{tag}</span>
                  )
                })
              }
            </div>
          </div>
        }
      </Modal>
      <div className="projects_container">
        {
          webProjects ? webProjects.map(({ src, title, tags, url, github }, idx) => {
            return (
              loading ? <Loading key={idx}  /> : <div key={idx} className="project_card">
                <div className="overlay">
                  <TbZoomInArea onClick={() => {
                    setprojectview({ ...projectview, src: src, title: title, tags: tags, url: url ,github:github })
                    setshow(true)
                  }} />
                </div>
                <div className="tags">
                  {
                    tags.map((tag, idx) => {
                      return (
                        <span key={idx}>{tag}</span>
                      )
                    })
                  }
                </div>
                <img src={src} alt={title} />
              </div>
            )
          })
            : 'No thing'
        }
      </div>
    </section>
  )
}

export default Portfolio